// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"9f96d65d","281":"8a28b14e","880":"ff39441c"}[chunkId] || chunkId) + "." + {"146":"ca8e0f35ab33b2f7","172":"1a9d3cfc4b836b27","281":"dd82f65bc9fdf1dc","870":"fec5ebdaff2a0356","880":"d5e14590c32ead2e"}[chunkId] + ".js";
};